import * as React from 'react'

const SvgComponent = props => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20' {...props}>
    <path d='M10 11c1.66 0 3 1.34 3 3 0 .85-.35 1.62-.92 2.16L10.17 18H13v2H7v-1.72l3.69-3.56A.997.997 0 0 0 10 13c-.55 0-1 .45-1 1H7c0-1.66 1.34-3 3-3Zm6 0v4h2v-4h2v9h-2v-3h-4v-6h2ZM2 10c0 2.53 1.17 4.78 3 6.25v2.42C2.01 16.93 0 13.7 0 10h2Zm8-10c5.18 0 9.45 3.95 9.95 9h-2.01c-.49-3.95-3.86-7-7.94-7-2.75 0-5.18 1.39-6.61 3.5H6v2H0v-6h2V4c1.82-2.43 4.73-4 8-4Z' />
  </svg>
)

export default SvgComponent
